import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './Statistics.css'
import ReactMarkdown from 'react-markdown'
import { extractFirstName, replaceSQL } from '../utils'
import axios from 'axios'
import endpoints from '../endpoints.json'

const Statistics = () => {
  const { state } = useLocation()
  const navigation = useNavigate()
  const [messages, setMessages] = useState(state?.messages)
  const [query, setQuery] = useState('')
  const [answer, setAnswer] = useState(state?.answer)
  const [results, setResults] = useState(state?.results)
  const [summary, setSummary] = useState(state?.summary)
  const [id, setId] = useState(state?.id)
  const [userId, setUserId] = useState(state?.userId)
  const [userMail, setUserMail] = useState(state?.userMail)
  const [index, setIndex] = useState(state?.index)
  const [showSystemMessage] = useState(state?.showSystemMessage)
  const [showSearchContextOptions] = useState(state?.showSearchContextOptions)
  const [searchContext, setSearchContext] = useState(state?.searchContext)
  const [language, setLanguage] = useState(state?.language)
  const [graphData, setGraphData] = useState(state?.graph)
  console.log(messages)

  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    console.log(state?.results[0].context)
  }, [])
  return (
    <div>
      <div className="header1">
        {/* Flex item for icon and text on the left */}
        <img
          className="stratsys-search-logo"
          src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
          alt="Stratsys Icon"
          style={{ width: '100px', height: 'auto' }}
        />
        <div class="one-ux-typography--heading-500" style={{ marginLeft: '30px' }}>
          <one-ux-text>Search Results Analysis</one-ux-text>
        </div>
        <div className="right-content">
          <one-ux-button
            onClick={() =>
              navigation(`/results`, {
                state: {
                  query,
                  answer,
                  results,
                  summary,
                  messages,
                  id,
                  userId,
                  userMail,
                  index,
                  showSystemMessage,
                  showSearchContextOptions,
                  searchContext,
                  language
                }
              })
            }
            purpose="notice"
            label="Go back"></one-ux-button>
        </div>
      </div>
      <div className="result-card" style={{ margin: '25px' }}>
        <h2>Statistics for Query: {state?.query}</h2>
        <p>Answer: {state?.answer}</p>
        <p>Summary: {state?.summary} </p>¨
      </div>
      {/* Map over the results array and render each result */}
      <div id="result-cards-container" className="result-cards">
        {state?.results.map((result, index) => (
          <div key={result.id} className="result-card">
            <h3>{result.title}</h3>
            <h4>Chunk id: {result.id}</h4>
            <p>Score: {result.score}</p>
            <p>Reranker Score: {result.reranker}</p>
            <p>{result.context.replace('  ', '\n\n')}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Statistics
